module.exports = __webpack_public_path__ + "static/media/Riolu_gaussian2.585ab17b.png";